import { createFileRoute } from '@tanstack/react-router'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@workspace/ui/components/card'
import {
  MicroFrontendErrorBoundary,
  RemoteLoader,
} from '@/components/micro-frontend'

export const Route = createFileRoute('/_authenticated/_organization/demo/skeleton')({
  component: SkeletonDemoPage,
})

function SkeletonDemoPage() {
  return (
    <div className='bg-background min-h-screen p-6'>
      <div className='mx-auto max-w-5xl'>
        <Card>
          <CardHeader>
            <CardTitle>Micro Frontend Demo</CardTitle>
            <CardDescription>
              This page demonstrates loading the skeleton micro frontend from a
              remote server via Module Federation.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className='rounded-lg border p-4'>
              <MicroFrontendErrorBoundary remoteName='skeleton'>
                <RemoteLoader remoteName='skeleton' moduleName='App' />
              </MicroFrontendErrorBoundary>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
